<template>
  <Button
    v-if="canEdit()"
    icon="pi pi-pencil"
    severity="success"
    class="w-7! h-7! p-2! mb-2! rounded-full!"
    :class="params.size && params.size.toUpperCase() === 'SMALL' ? 'w-5! h-5! mb-1!' : ''"
    @click="params.callback(props.params.data)"
    aria-label="Edit"
  ></Button>
</template>

<script setup lang="ts">
const props = defineProps(["params"]);

const canEdit = (): boolean => {
  if (props.params.checkEditable != null) return props.params.checkEditable(props.params.data);
  return true;
};
</script>
